<template>
  <div v-for="option in filteredOptions" :key="option.id">
    <div v-if="useProductOptionButtons" class="option-buttons">
      <Button
        v-for="value in option.values"
        :key="value"
        class="option"
        :class="{
          'option--selected': isSelectedOption(option, value),
        }"
        theme="outline"
        @click="handleOptionChange(option, value)"
      >
        {{ value }}
      </Button>
    </div>

    <div v-else class="input input--dropdown">
      <select
        data-testid="product-options"
        class="input__element input__element--dropdown"
        @change="handleOptionChange(option, $event.target.value)"
      >
        <option selected disabled>Select {{ option.name }}</option>
        <option
          v-for="value in option.values"
          :key="value"
          :selected="isSelectedOption(option, value)"
        >
          {{ value }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from "@/components/Button.vue";
import { getFeatureToggles } from "@/helpers/featureToggles";
export default {
  name: "ProductOptions",
  components: {
    Button,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("product", ["selectedOptions"]),
    filteredOptions() {
      return this.options.filter((option) => option.values.length > 1);
    },
    useProductOptionButtons() {
      const { productOptionButtons = false } = getFeatureToggles();
      return productOptionButtons;
    },
  },
  mounted() {
    this.options.forEach((option) => {
      if (option.values.length === 1) {
        this.changeProductOption({
          id: option.id,
          name: option.name,
          value: option.values[0],
        });
      }
    });
  },
  methods: {
    ...mapActions("product", ["changeProductOption"]),
    handleOptionChange(option, value) {
      this.changeProductOption({
        id: option.id,
        name: option.name,
        value: value,
      });
    },
    isSelectedOption(option, value) {
      return this.selectedOptions.some(
        (selectedOption) =>
          selectedOption.id === option.id && selectedOption.value == value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";

.option-buttons {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-items: flex-start;
  align-items: center;
}

.option {
  border: 1px solid $color-grey;
  width: 100%;

  &--selected {
    border-color: $color-dark;
  }
}
</style>
